// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"5061b28e83f788e2c5d5","655":"deab67198dca8d5d5c6c"}[chunkId] + ".js";
};